export default "__VITE_ASSET__BxlbOvey__"